export { NotFoundPageWrapper } from './NotFoundPageWrapper.styles';
